import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Per-page SEO block. Pass a page-specific title + description and it composes
 * the full <head> block including OG, Twitter, canonical, and optional JSON-LD.
 *
 * Usage:
 *   <SEO
 *     title="Fact-check any claim in seconds"
 *     description="..."
 *     path="/shop"
 *     jsonLd={{ ... }}
 *   />
 */
export default function SEO({
    title,
    description,
    path = "/",
    ogImage,
    keywords,
    noindex = false,
    jsonLd,
}) {
    const baseUrl = "https://real-check.org";
    const url = `${baseUrl}${path}`;
    const fullTitle = title
        ? `${title} · Real-Check.org`
        : "Real-Check.org — Real-Time Fact Checking & AI Scam Detector";
    const img = ogImage || `${baseUrl}/og-default.png`;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            {description && <meta name="description" content={description} />}
            {keywords && <meta name="keywords" content={keywords} />}
            {noindex && <meta name="robots" content="noindex, nofollow" />}
            <link rel="canonical" href={url} />
            <meta property="og:title" content={fullTitle} />
            {description && <meta property="og:description" content={description} />}
            <meta property="og:url" content={url} />
            <meta property="og:image" content={img} />
            <meta name="twitter:title" content={fullTitle} />
            {description && <meta name="twitter:description" content={description} />}
            <meta name="twitter:image" content={img} />
            {jsonLd && (
                <script type="application/ld+json">
                    {JSON.stringify(jsonLd)}
                </script>
            )}
        </Helmet>
    );
}
